const LogisticsCardUpData = [
  { card1up1: 35, card1dnP: "ONGOING DELIVERY" },
  { card1up1: 20, card1dnP: "FAILED DELIVERY" },
  { card1up1: 30, card1dnP: "RETURNS" },
  { card1up1: 5, card1dnP: "PRODUCTS" },
  { card1up1: 5, card1dnP: "EMPLOYEES ON LEAVE" },
];
export { LogisticsCardUpData };
const LogisticsCardDnData = [
  { card1up1: `$ 321,876`, card1dnP: "REVENUE" },
  { card1up1: `80%`, card1dnP: "DELIVERY STATUS" },
  { card1up1: `7.2 hrs`, card1dnP: "AVG DELIVERY TIME" },
  { card1up1: 1, card1dnP: "COUNTRIES" },
  { card1up1: 5, card1dnP: "EMPLOYEES ON LEAVE" },
];
export { LogisticsCardDnData };
